// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M7 22H2V20H7V22Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M15 22H9V20H15V22Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 22H17V20H22V22Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M15.7773 5.5C17.0352 5.5 18.0554 6.51956 18.0557 7.77734C18.0557 9.03533 17.0353 10.0557 15.7773 10.0557C14.5196 10.0554 13.5 9.03518 13.5 7.77734C13.5002 6.51971 14.5197 5.50023 15.7773 5.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 18H2V2H22V18ZM4 11.2432L8.29395 7.7041L18.3584 16H20V4H4V11.2432Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-image-carousel-filled')
export default class ImageCarouselFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'image-carousel-filled',
    }
  }
}
